module.exports = __webpack_public_path__ + "media/唯一後悔過的事是讓你離開我身邊.e41ba1fa.mp3";